import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/imdb': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM21.3 229.2h-0.3c0.1-0.1 0.2-0.3 0.3-0.4v0.4zM97 319.8v-127.8h-33v127.8h33zM210.2 319.8v-127.8h-43l-7.6 59.9c-2.7-20-5.4-40.1-8.7-59.9h-42.8v127.8h29v-84.5l12.2 84.5h20.6l11.6-86.4v86.4h28.7zM221.6 319.8c86.1 0.1 75 6 75-82.5 0-8.1 0.3-16.8-1.4-24.4-4.3-22.5-31.4-20.9-49-20.9h-24.6v127.8zM382.5 290.6v-36c0-17.3-0.8-30.1-22.2-30.1-8.9 0-14.9 2.7-20.9 9.2v-41.7h-31.7v127.8h29.8l1.9-8.1c5.7 6.8 11.9 9.8 20.9 9.8 19.8 0 22.2-15.2 22.2-30.9zM265 229.9v49.3c0 9.7 1.9 18.7-10.3 18.4v-83.7c11.9 0 10.3 6.3 10.3 16zM350.5 256v32.7c0 5.4 1.6 14.4-6.2 14.4-1.6 0-3-0.8-3.8-2.4-2.2-5.1-1.1-44.1-1.1-44.7 0-3.8-1.1-12.7 4.9-12.7 7.3 0 6.2 7.3 6.2 12.7z'
      }
    ]
  }
})
